/*
 * Copyright (c) Dito Technologies
 */

import environment from "constants/environment"
import {commitMutation, GraphQLTaggedNode} from "react-relay";
import {PayloadError} from "relay-runtime";

function PerformPromise<T>(mutation: GraphQLTaggedNode, variables: Record<string, unknown>): Promise<T> {
    return new Promise<T>((resolve, reject) => {
        commitMutation(environment, {
            mutation,
            variables,
            onCompleted: (response, errors) => {
                if (errors) {
                    let outputError: PayloadError | undefined = undefined;
                    for (const error of errors) {
                        outputError = error
                        if (outputError) {
                            break;
                        }
                    }
                    reject(outputError)
                } else {
                    resolve(response as T);
                }
            },
            onError: (payload: any) => {
                const errors: PayloadError[] = payload.errors;
                if (!errors) {
                    reject(undefined);
                } else {
                    reject(errors[0]);
                }
            },
        });
    })
}

export default PerformPromise;
